import React from 'react';
import page404 from "../common/images/page-404.png";

export default function Page404() {

  return (<div className="page404-main">
             <img src={page404} alt='page-404' />
        </div>);
}